module.exports = __webpack_public_path__ + "static/media/github-pages.191b2dad.png";